const getIsStyleParam = styleParams => {
  var _styleParams$booleans, _styleParams$numbers, _styleParams$colors, _styleParams$fonts;
  return Object.keys((_styleParams$booleans = styleParams.booleans) != null ? _styleParams$booleans : {}).length > 0 || Object.keys((_styleParams$numbers = styleParams.numbers) != null ? _styleParams$numbers : {}).length > 0 || Object.keys((_styleParams$colors = styleParams.colors) != null ? _styleParams$colors : {}).length > 0 || Object.keys((_styleParams$fonts = styleParams.fonts) != null ? _styleParams$fonts : {}).length > 0;
};
export const getStyleParamsTheme = _ref => {
  let {
    customTheme,
    styleParams
  } = _ref;
  const styleParamDefined = getIsStyleParam(styleParams);
  if (styleParamDefined) {
    return {
      palette: {
        type: 'rgb',
        bgColor: 'var(--wix-forms-formInputBackgroundColor)',
        textColor: 'var(--wix-forms-formParagraphColor)',
        actionColor: 'var(--wix-forms-formLinkColor)'
      },
      ...customTheme
    };
  }
  return defaultTheme;
};
const defaultTheme = {
  customStyles: {
    h1: {
      fontSize: '28px'
    },
    h2: {
      fontSize: '20px'
    },
    p: {
      fontSize: '16px'
    }
  }
};
export const getHeaderAndParagraphCustomStyles = () => {
  return {
    h1: {
      fontSize: 'var(--wix-forms-formHeaderOneFont-size)',
      fontFamily: 'var(--wix-forms-formHeaderOneFont-family)',
      color: 'rgb(var(--wix-forms-formHeaderOneColor))'
    },
    h2: {
      fontSize: 'var(--wix-forms-formHeaderTwoFont-size)',
      fontFamily: 'var(--wix-forms-formHeaderTwoFont-family)',
      color: 'rgb(var(--wix-forms-formHeaderTwoColor))'
    },
    p: {
      fontSize: 'var(--wix-forms-formParagraphFont-size)',
      fontFamily: 'var(--wix-forms-formParagraphFont-family)',
      color: 'rgb(var(---wix-forms-formParagraphColor))'
    }
  };
};
//# sourceMappingURL=theme-utils.js.map